<!-- Loading bar -->
@if (loading) {
  <mat-progress-bar class="absolute inset-x-0 top-0 h-0.5" [mode]="'indeterminate'">
  </mat-progress-bar>
}
<!-- Form -->
@if (!loading) {
  <div class="flex flex-col flex-auto overflow-y-auto lg:overflow-hidden bg-card dark:bg-default">
    <ng-container *ngTemplateOutlet="databaseViewMode ? databaseView : designView"></ng-container>
  </div>
}

<!-- Design View -->
<ng-template #designView>
  <!-- Messages -->
  @if (!repo?.evened && showAlerts?.showEvened && !isNew) {
    <div class="flex pl-2 pr-2 items-center w-full bg-amber-100 dark:bg-amber-500">
      <mat-icon class="mat-icon notranslate icon-size-5 mat-icon-no-color mr-2 flex" aria-hidden="true"[svgIcon]="'heroicons_solid:exclamation'"></mat-icon>
      <span class="flex-auto"> {{ 'dtypeAlerts.unevened' | transloco }} </span>
      <button class="flex place-self-end" mat-icon-button matTooltip="{{'close' | transloco}}" (click)="showAlerts.showEvened = false">
        <mat-icon class="mat-icon notranslate icon-size-5 mat-icon-no-color" [svgIcon]="'heroicons_outline:x'"></mat-icon>
      </button>
    </div>
  }
  <!-- Header -->
  <div class="relative flex flex-row flex-0 w-full bg-gray-100 dark:bg-transparent">
    <div class="flex flex-col flex-auto items-center justify-start">
      <!-- Go to Buttons -->
      <div class="flex p-4 items-center justify-start w-full">

        <!-- Go to summary-->
        @if (repo && hasLiveRelease) {
          <button mat-raised-button class="mr-4" [routerLink]="['../summary']" [queryParams]="params">
            <mat-icon class="mat-icon notranslate icon-size-5 mat-icon-no-color" aria-hidden="true"[svgIcon]="'heroicons_solid:external-link'"></mat-icon>
            <span class="pl-1">{{ 'summary' | transloco }}</span>
          </button>
        }

        <!-- Go to BBDD view-->
        @if (role?.dataVerifier) {
          <button mat-raised-button class="mr-4 mat-focus-indicator mat-stroked-button mat-button-base" (click)="changeView()">
            <mat-icon class="mat-icon notranslate icon-size-5 mat-icon-no-color" aria-hidden="true"[svgIcon]="'heroicons_solid:external-link'"></mat-icon>
            <span class="pl-1">{{ 'tableInfo' | transloco }}</span>
          </button>
        }
      </div>


      <!-- Title -->
      <div class="px-6 py-4 text-3xl font-semibold tracking-tight w-full flex items-center">
        {{ form?.caption ? (form.caption | localize) : ('newForm' | transloco) }}
        <!-- Icons -->
        @if (!isNew) {
          <!-- Design View -->
          @if (repo?.status === 'DESIGN') {
            <mat-icon class="ml-2" [svgIcon]="'mat_outline:draw'" [ngStyle]="{'color':'orange'}" matTooltip="{{'repositoryIcons.design' | transloco}}"></mat-icon>
          }
          <!-- Live View -->
          @if (repo?.status === 'LIVE') {
            <mat-icon class="ml-2" [svgIcon]="'feather:heart'" [ngStyle]="{'color':'green'}" matTooltip="{{'repositoryIcons.live' | transloco}}"></mat-icon>
          }
          <!-- Static View -->
          @if (repo?.status === 'STATIC') {
            <mat-icon class="ml-2" [svgIcon]="'feather:anchor'" [ngStyle]="{'color':'black'}" matTooltip="{{'repositoryIcons.static' | transloco}}"></mat-icon>
          }
          @if (repo?.status !== 'STATIC') {
            <!-- Locked -->
            @if (repo?.locked) {
              <mat-icon class="ml-2" [svgIcon]="'heroicons_solid:lock-closed'" [ngStyle]="{'color':'red'}" matTooltip="{{'repositoryIcons.locked' | transloco}}"></mat-icon>
            }
            <!-- Unlocked -->
            @if (!repo?.locked) {
              <mat-icon class="ml-2" [svgIcon]="'heroicons_solid:lock-open'" [ngStyle]="{'color':'green'}" matTooltip="{{'repositoryIcons.unlocked' | transloco}}"></mat-icon>
            }
            <!-- Evened -->
            @if (repo?.evened) {
              <mat-icon class="ml-2" [svgIcon]="'heroicons_outline:status-online'" [ngStyle]="{'color':'green'}" matTooltip="{{'repositoryIcons.evened' | transloco}}"></mat-icon>
            }
            <!-- Unevened -->
            @if (!repo?.evened) {
              <mat-icon class="ml-2" [svgIcon]="'heroicons_outline:status-offline'" [ngStyle]="{'color':'orange'}" matTooltip="{{'repositoryIcons.unevened' | transloco}}"></mat-icon>
            }
            <!-- Has Request -->
            @if (repo?.dtypeToGoLiveRequest && !repo?.dtypeToGoLiveSchedule && !repo?.migrating) {
              <mat-icon class="ml-2" [svgIcon]="'mat_outline:note_add'" [ngStyle]="{'color':'orange'}" matTooltip="{{'repositoryIcons.hasRequest' | transloco}}"></mat-icon>
            }
            <!-- Has Schedule -->
            @if (repo?.dtypeToGoLiveSchedule && !repo?.migrating) {
              <mat-icon class="ml-2" [svgIcon]="'feather:clock'" [ngStyle]="{'color':'orange'}" matTooltip="{{'repositoryIcons.hasSchedule' | transloco}}"></mat-icon>
            }
            <!-- Migrating -->
            @if (repo?.migrating) {
              <mat-icon class="ml-2" [svgIcon]="'mat_outline:sync_problem'" [ngStyle]="{'color':'red'}" matTooltip="{{'repositoryIcons.migrating' | transloco}}"></mat-icon>
            }
            <!-- Error Status -->
            @if (repo?.errorStatus === 'ERROR') {
              <mat-icon class="ml-2" [svgIcon]="'mat_outline:error_outline'" [ngStyle]="{'color':'red'}" matTooltip="{{'repositoryIcons.errors' | transloco}}"></mat-icon>
            }
          }
        }
      </div>
    </div>

    <!-- Action buttons -->
    <div class="flex flex-col items-start flex-auto">
      <div class="flex p-4 justify-end w-full">

        <!-- Menu button -->
        @if (repo?.status !== 'STATIC' && !repo?.dtypeToGoLiveRequest && ((!repo?.evened && hasLiveRelease) || (!repo?.locked && !isNew))) {
          <button class="mr-8" mat-flat-button
            color="accent" [matMenuTriggerFor]="menu">
            <mat-icon class="text-on-accent" [svgIcon]="'mat_solid:expand_more'"></mat-icon>
            <span class="ml-2 mr-1">{{ 'services.taskPlanning.availableActions' | transloco}}</span>
          </button>
        }
        <!-- Menu -->
        <mat-menu #menu="matMenu">
          <!-- Discard Design -->
          @if (!repo?.evened && hasLiveRelease) {
            <button mat-menu-item (click)="discardDesign()">
              <mat-icon [svgIcon]="'heroicons_outline:trash'" class="icon-size-5"></mat-icon>
              <span>{{ 'discardDesign' | transloco}}</span>
            </button>
          }
          @if (!repo?.locked && !isNew) {
            <button mat-menu-item (click)="changeRepoName()">
              <mat-icon [svgIcon]="'heroicons_outline:pencil-alt'" class="icon-size-5"></mat-icon>
              <span>{{ 'changeRepoName' | transloco}}</span>
            </button>
          }
        </mat-menu>

        <!-- Delete -->
        @if (!isNew) {
          <button mat-raised-button class="mr-4" color="warn" (click)="deleteRepository()">{{ 'delete' | transloco }}</button>
        }

        <!-- Cancel -->
        <button mat-raised-button class="mr-4" color="warn" (click)="cancel()">{{ 'cancel' | transloco }}</button>

        <!-- Save -->
        <button mat-raised-button class="mr-4" color="primary" (click)="save()" [disabled]="$safeNavigationMigration(repo?.dtypeToGoLiveRequest)">{{ 'save' | transloco }}</button>
      </div>
    </div>
  </div>

  <!-- Alerts -->
  @if (form?.alert?.length > 0) {
    <div class="flex flex-col w-full py-4 px-8 space-y-4 bg-gray-100 dark:bg-transparent">
      @for (al of form.alert; track al) {
        <fuse-alert [type]="al.type.toLowerCase()" appearance="outline">
          <span fuseAlertTitle>{{ al.type === 'ERROR' ? 'Error' : al.type === 'WARNING' ? ('warning' | transloco) : 'Info' }}</span>
          {{ $safeNavigationMigration(al?.text) | localize }}
        </fuse-alert>
      }
    </div>
  }

  <div class="flex flex-col flex-auto flex-shrink-0 lg:flex-shrink p-3 lg:overflow-y-auto bg-gray-100 dark:bg-transparent"
    fuseScrollReset>

    <!-- Tabs -->
    @if (form && dtypeForm) {
      <mat-tab-group class="sm:px-2" animationDuration="0" [selectedIndex]="selectedTab" (selectedIndexChange)="selectedTab = $event">
        <!-- Datatype general data -->
        <mat-tab label="{{ 'general' | transloco }}">
          <dtype-details [dtypeForm]="dtypeForm" [isUpdate]="!isNew"></dtype-details>
          @if (role?.systemConfig) {
            <h1 class="font-semibold text-xl tracking-tight leading-6">{{ 'advancedOptions' | transloco }}</h1>
            <mat-form-field class="w-full p-2">
              <mat-label>{{ 'advancedCommand' | transloco }}</mat-label>
              <input matInput [(ngModel)]="form.advancedCommand">
            </mat-form-field>
          }
        </mat-tab>
        <!-- Form fields -->
        <mat-tab label="{{ 'fields' | transloco }}">
          <ng-template matTabContent>
            <dtype-fieldlist [dtype]="form" [locator]="dtypeLocator" (changed)="childChanged($event)"></dtype-fieldlist>
          </ng-template>
        </mat-tab>
        <!-- Form categories -->
        <!-- <mat-tab label="{{ 'categories' | transloco }}">
        <ng-template matTabContent>
          Categorías
        </ng-template>
      </mat-tab> -->
      <!-- Editor preview -->
      <mat-tab label="{{ 'editorPreview' | transloco }}">
        <ng-template matTabContent>
          <dtype-editor-preview [dtype]="form" [status]="'DESIGN'"></dtype-editor-preview>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  }
</div>
</ng-template>

<!-- Database Tables View -->
<ng-template #databaseView>
  <!-- Header -->
  <div class="z-10 relative flex flex-row items-center flex-0 w-full bg-gray-100 dark:bg-transparent">
    <div class="flex flex-col flex-auto items-center justify-start">
      <!-- Go to Buttons -->
      <div class="flex p-4 items-center justify-start w-full">
        <!-- Go to design view-->
        <button mat-raised-button class="mat-focus-indicator p-4 mat-stroked-button mat-button-base mr-4" (click)="changeView()" [disabled]="repo?.locked && repo?.dtypeToGoLiveRequest">
          <mat-icon class="mat-icon notranslate icon-size-5 mat-icon-no-color" aria-hidden="true"[svgIcon]="'heroicons_solid:external-link'"></mat-icon>
          <span class="pl-1">{{ 'design' | transloco}}</span>
        </button>
        <!-- Go to summary-->
        @if (repo && hasLiveRelease) {
          <button mat-raised-button class="mr-4" [routerLink]="['../summary']" [queryParams]="params" (click)="changeView()">
            <mat-icon class="mat-icon notranslate icon-size-5 mat-icon-no-color" aria-hidden="true"[svgIcon]="'heroicons_solid:external-link'"></mat-icon>
            <span class="pl-1">{{ 'summary' | transloco }}</span>
          </button>
        }
      </div>
    </div>
  </div>

  <div class="flex flex-col flex-auto flex-shrink-0 lg:flex-shrink p-3 lg:overflow-y-auto bg-gray-100 dark:bg-transparent"
    fuseScrollReset>
    <database-table-view [data]="repo" [uri]="uri" [dtypeLocator]="dtypeLocator" [hasLiveRelease]="hasLiveRelease"></database-table-view>
  </div>
</ng-template>